import { combineReducers } from "redux";
import settings from "./settings/reducer";
import menu from "./menu/reducer";
import auth from "./auth/reducer";
import iot from "./iot/reducer";
import requestApp from "./request/reducer";
import bookingApp from "./booking/reducer";
import alacarteApp from "./alacarte/reducer";
import serviceApp from "./service/reducer";
import * as IoT from "./iot/aws-iot";

const appReducer = combineReducers({
  menu,
  settings,
  auth,
  iot,
  requestApp,
  bookingApp,
  alacarteApp,
  serviceApp,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET") {
    try {
      IoT.endClient();
    } catch (err) {
      console.error("iot end err", err);
    }
    try {
      const { settings } = state;
      state = { settings };
    } catch (err) {
      console.error("settings state err", err);
    }
  }
  if (action.type === "FORCE_RELOAD") {
    try {
      IoT.endClient();
    } catch (err) {
      console.error("iot end err", err);
    }
    try {
      localStorage.removeItem("hotelConfig");
      sessionStorage.clear();
    } catch (err) {
      console.error("reset storage err", err);
    }
    try {
      const { settings } = state;
      state = { settings };
    } catch (err) {
      console.error("settings state err", err);
    }

    navigator.serviceWorker.getRegistration().then(reg => {
      reg.unregister().then(() => {
        window.location.reload();
      });
    });
  }
  return appReducer(state, action);
};

export default rootReducer;
